export default __webpack_public_path__ + "static/media/postGres.682792a9.png";